// admin 목록 공용 "더 보기" 버튼. hasMore일 때만 렌더.
export default function LoadMoreButton({ hasMore, onClick, shown, total, label = '더 보기' }) {
  if (!hasMore) return null;
  return (
    <div style={{ textAlign: 'center', margin: '12px 0' }}>
      <button
        onClick={onClick}
        style={{
          padding: '8px 20px', borderRadius: 6, border: '1px solid #ddd',
          background: '#fff', color: '#333', fontSize: 14, cursor: 'pointer',
        }}
      >
        {label}{(shown != null && total != null) ? ` (${shown}/${total})` : ''}
      </button>
    </div>
  );
}
